import React from 'react';
import AppleLogin from './AppleLogin';
import FacebookLogin from './FacebookLogin';
import GoogleLogin from './GoogleLogin';
import { isIosApp, isIosWeb } from '../../../../utils/platform';

const CSS = require('./AuthButtons.less');

interface AuthButtonsProps {
  isLogin?: boolean;
  afterLogin?: () => any;
  companyName?: string;
}

const onLoginResult = (setState: (any) => any) => ({ error, success, redirectUrl }: { error?: any; success: boolean; redirectUrl?: string }) =>  {
  if (!success) {
    console.error(`Login failed: ${error}`);
    setState({ error: `Login failed: ${error}`, loading: false });
    return;
  }

  setState({ error: null, loading: false });

  if (redirectUrl) {
    window.location.href = redirectUrl;
    return;
  }

  window.location.reload();
};

function AuthButtons({ isLogin, afterLogin }: AuthButtonsProps) {
  const searchParams = new URLSearchParams(window.location.search);
  const returnTo = searchParams.get('returnTo') || '/';

  const AppleAuthButton = <AppleLogin isLogin={isLogin} afterLogin={afterLogin} callbackUrl={returnTo} onLoginResult={onLoginResult} />;

  return (
    <div className={CSS.AuthButtons}>
      {(isIosApp() || isIosWeb()) && AppleAuthButton}
      <FacebookLogin isLogin={isLogin} afterLogin={afterLogin} callbackUrl={returnTo} onLoginResult={onLoginResult} />
      {!isIosApp() && !isIosWeb() && AppleAuthButton}
      <GoogleLogin isLogin={isLogin} afterLogin={afterLogin} callbackUrl={returnTo} onLoginResult={onLoginResult} />
    </div>
  );
}

export default AuthButtons;
